var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "custom-class": "custom-dialog",
        width: _vm.width,
        title: _vm.title,
        "append-to-body": "",
        "close-on-click-modal": _vm.clickClose,
        "destroy-on-close": _vm.closeFree,
        visible: _vm._value,
        top: _vm.top,
      },
      on: {
        "update:visible": function ($event) {
          _vm._value = $event
        },
        close: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _vm._t("default"),
      _vm.showFooter
        ? _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.cancelText))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("ok")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.okText))]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }